// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__13Nf0","additionalInfo":"AgreementModal_additionalInfo__nqzrA"};